import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { getFaqs } from "../lib/api";

export default function FAQAccordion({ page, items: itemsProp, heading = "Frequently Asked Questions" }) {
  const [items, setItems] = useState(itemsProp || []);
  useEffect(() => {
    if (!itemsProp && page) {
      getFaqs(page).then(setItems).catch(() => setItems([]));
    }
  }, [page, itemsProp]);
  if (!items.length) return null;
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
  return (
    <section className="max-w-3xl mx-auto" data-testid={`faq-${page || "custom"}`}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <h2 className="font-heading font-bold text-2xl sm:text-3xl text-slate-900 mb-6 text-center">{heading}</h2>
      <Accordion type="single" collapsible className="w-full">
        {items.map((f, i) => (
          <AccordionItem key={f.id || i} value={`faq-${i}`} className="border-slate-200">
            <AccordionTrigger className="text-left font-heading font-semibold text-slate-900 hover:text-sky-700 hover:no-underline" data-testid={`faq-trigger-${i}`}>
              {f.question}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 leading-relaxed">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
